// Émis dans assets/images/ pour les templates PHP (fiche entrepreneur, bottin).
import './images/placeholder-cc.webp';
import './js/city-autocomplete.js';
import './js/contact-details-format.js';
import './js/pmpro-field-validation.js';
import './js/dashboard-project-confirm.js';
// Active le JavaScript (accessibilité progressive)
document.body.classList.add('js-enabled');

function closeMenu() {
    jQuery('.MenuFullWidth__content-wrapper').hide();
    jQuery('.close_menu').hide();
    jQuery('body').removeClass('burger-activated');
    jQuery('html').removeClass('menu-open');
}

/**
 * Ouverture du menu burger
 */
function openMenu() {
    jQuery('body').addClass('burger-activated');
    jQuery('.close_menu').show();
    jQuery('.MenuFullWidth__content-wrapper').show();
    jQuery('html').addClass('menu-open');
}

// Événements d'ouverture/fermeture
jQuery('body').on('click', '.button--menu', openMenu);
jQuery('.close_menu').on('click', closeMenu);

/**
 * Navigation vers un sous-menu
 */
jQuery('body').on('click', '.menu .menu-item-has-children > a', function (e) {
    e.preventDefault();
    const $link = jQuery(this);
    const $submenu = $link.next('.MenuFullWidth__sub-menu');
    const $wrapper = jQuery('.MenuFullWidth__content-wrapper');
    
    // Animation de transition vers le sous-menu
    $wrapper.fadeOut(400);
    
    setTimeout(function() {
        $submenu.addClass('MenuFullWidth__sub-menu--active');
        $wrapper.fadeIn(400);
    }, 450);
});

/**
 * Retour au menu principal depuis un sous-menu
 */
jQuery('.btn-return').on('click', function () {
    const $wrapper = jQuery('.MenuFullWidth__content-wrapper');
    
    // Animation de retour au menu principal
    $wrapper.fadeOut(400);
    
    setTimeout(function() {
        jQuery('.MenuFullWidth__sub-menu').removeClass('MenuFullWidth__sub-menu--active');
        $wrapper.fadeIn(400);
    }, 450);
}); 
